import React, { useCallback, useEffect, useState } from 'react'
import './style.scss'
import Requests from '../../../../utils/Requests/Index'
import AddsenseTable from '../../../../components/table/Addsense'
import LoadingComponent from '../../../../components/loading/Index'
// import Icon from 'react-icons-kit'
// import { Link } from 'react-router-dom'
// import { plus } from 'react-icons-kit/feather'

const Index = () => {
    const [isLoading, setLoading] = useState(true)
    const [items, setItems] = useState([])
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    // Fetch data
      // Fetch data
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await Requests.Addsense.Index(header);

      if (Array.isArray(data)) {
        setItems(data);
      } else {
        setItems([]); // fallback if not array
      }
    } catch (error) {
      console.error('Failed to fetch Addsense data:', error);
      setItems([]); // clear items on error
    } finally {
      setLoading(false);
    }
  }, [header]);

  useEffect(() => {
    fetchData();
    // ✅ fetchData already has header inside its deps, so we don’t need "header" separately here
  }, [fetchData]);

    // useEffect(() => {
    //     fetchData()
    // }, [header, fetchData])

    return (
        <div className="addsense-index pb-4">
            {/* if loading to fetch data */}
            {isLoading ? <LoadingComponent /> : null}

            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex">
                                    <div><h6 className="mb-0">Addsense List</h6></div>
                                    {/* <div className="ml-auto">
                                        <Link
                                            to="/dashboard/marketing/web-ad/create"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={plus} size={22} />
                                        </Link>
                                    </div> */}
                                </div>
                            </div>

                            {/* Data table component for show data */}
                            <div className="card-body p-0">
                                <AddsenseTable items={items} refetch={fetchData} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index;